import React from 'react'
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import { browserHistory } from 'react-router'
import { values } from 'lodash'

import { replaceQuery } from '../../lib/AppTools.js'

type Props = {
  sortingMethods: { 
    [string]: { value: string, name: string, sort: string|(Object => string) }
  }, 
  query: {
    filterType: ?string, 
    filter: ?string
  },
  includeLabel: boolean
}

const SortSelector = ({ sortingMethods, query, includeLabel }: Props) => (
  <FormGroup>
    {
      includeLabel && (
        <ControlLabel>Ordenar por:</ControlLabel>
      )
    }
    <FormControl 
      componentClass="select"
      bsSize="xsmall"
      value={query.sortBy || "con"}
      onChange={evt => replaceQuery(browserHistory, query, { sortBy: evt.target.value })}
      style={{ marginLeft: 10 }}
    >
      {
        values(sortingMethods).map(m => (
          <option key={m.value} value={m.value}>{m.name}</option>
        ))
      }
    </FormControl>
  </FormGroup>
)

export default SortSelector
